module.exports = __webpack_public_path__ + "static/img/solution-check-pc-en.c990c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-check-pc-en.png
// module id = SNe3
// module chunks = 1